import { uid, Platform } from 'quasar';
import api from '../../lib/api/actions';

export async function addProduct({ commit }, { product }) {
  if (product) {
    if (!product.uid) {
      product.uid = uid();
    }

    // Converting to JSON and back strips all observers from the object
    commit('addProduct', JSON.parse(JSON.stringify(product)));
    // commit('addProduct', product);
  }
}

export async function updateProduct({ commit }, payload) {
  if (payload.product) {
    commit('updateProduct', payload);
  }
}

export async function flush({ commit }) {
  commit('flush');
}

export async function updateQuantity({ commit }, payload) {
  if (payload) {
    commit('updateProductQuantity', payload);
  }
}

export async function createWoltShipmentPromise(context, {
  deliveryMethodId, locationId, city, postCode, street, lat, lon, comment,
}) {
  const response = await api.createWoltShipmentPromise(
    deliveryMethodId, locationId, city, postCode, street, lat, lon, comment,
  );
  return response;
}

export async function fetchLastOrder({ commit }) {
  const response = await api.fetchLastOrderFromAPI();

  if (response.status === 200) {
    commit('updateLastOrder', response.data);
  }
}

export async function fetchOrder(context, { id }) {
  const response = await api.fetchOrderFromAPI({ id });

  if (response.status === 200) {
    return response.data;
  }

  return null;
}

export async function removeProductFromCartById({ commit }, payload) {
  commit('removeProductFromCart', payload);
}

export async function checkIfValidCouponCode({ commit }, { coupon, deliveryMethodId }) {
  const response = await api.checkIfValidCouponCode({ coupon, deliveryMethodId });

  if (response.status === 200) {
    if (response.data.context === 2 && Platform.is.cordova) {
      throw new Error('couponNeedsDesktop');
    }
    else if (response.data.context === 3 && !Platform.is.cordova) {
      throw new Error('couponNeedsCordova');
    }
    else {
      commit('setValidCouponCode', response.data);
    }
  }
}

export async function setCreditFlag({ commit }, payload) {
  commit('setCreditFlag', payload);
}

export async function submitOrder({ commit }, payload) {
  const response = await api.submitUsersOrder(payload);

  if (response.status === 200 && response.data.success) {
    commit('updateLastOrder', response.data.data);
  }
  else {
    const error = new Error(response.data.error);
    error.code = response.data.code;
    throw error;
  }
}

export async function postPayment(context, {
  orderUuid, paymentMethodId, paymentData, saveAsVirtual,
}) {
  const response = await api.submitUsersPayment({
    orderUuid, paymentMethodId, paymentData, saveAsVirtual,
  });
  if (response.status === 200) {
    return response.data;
  }

  const error = new Error(response.data.error);
  error.code = response.data.code;
  throw error;
}

export async function setSelectedOptions({ commit }, payload) {
  commit('setSelectedOptions', payload);
}

export async function setSelectedSideOptions({ commit }, payload) {
  commit('setSelectedSideOptions', payload);
}

export async function setSelectedProductIndex({ commit }, payload) {
  commit('setSelectedProductIndex', payload);
}

export async function setDeliveryMethod({ commit }, payload) {
  commit('setDeliveryMethod', payload);
  // Remove coupon if delivery method is changed
  commit('setValidCouponCode', null);
}

export async function setSelectedProductQuantity({ commit }, payload) {
  commit('setSelectedProductQuantity', payload);
}

export async function setPaymentMethod({ commit }, payload) {
  if (payload) {
    commit('setPaymentMethod', payload);
  }
}

export async function updateTotalPrice({ commit }, payload) {
  commit('updateTotalPrice', payload);
}

export async function setOrderReadyTime({ commit }, payload) {
  if (payload) {
    commit('setOrderReadyTime', payload);
  }
}

export async function setOrderStatusArrived(context, orderId) {
  await api.setOrderStatusArrived(orderId);
}
